module.exports = __webpack_public_path__ + "static/media/crutches.6616d4ec.svg";